<template>
    <v-container fluid class="text-xs-center"> 
        <v-layout row wrap>
            <v-form>
                <v-container>
                    <div class="vrow">
                        <h4>{{$t('labels.speciesData')}}</h4>
                        <v-text-field
                            v-model="speciesSingle.name"
                            :counter="40"
                            label="Nome"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="speciesSingle.lastname"
                            :counter="40"
                            label="Cognome"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="speciesSingle.telephone"
                            :counter="15"
                            label="Telefono"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="speciesSingle.mobilePhone"
                            :counter="15"
                            label="Cellulare"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="speciesSingle.email"
                            :counter="64"
                            label="E-mail"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="speciesSingle.birthPlace"
                            :counter="40"
                            label="Luogo di nascita"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="speciesSingle.birthday"
                            type="date"
                            label="Compleanno"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="speciesSingle.fiscalCode"
                            :counter="18"
                            label="Codice fiscale"
                            required
                        ></v-text-field>
                    </div>
                    <div class="vrow">
                        <h4>Indirizzo di residenza</h4>
                        <v-text-field
                            v-model="speciesSingle.residenceStreet"
                            :counter="40"
                            label="Via / Corso / Piazza"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="speciesSingle.residenceStreetNumber"
                            :counter="5"
                            label="N° Civico"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="speciesSingle.residenceZipCode"
                            :counter="5"
                            label="CAP"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="speciesSingle.residenceCity"
                            :counter="40"
                            label="Città"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="speciesSingle.residenceProvince"
                            :counter="2"
                            label="Provincia (2 lettere)"
                            required
                        ></v-text-field>
                        
                    </div>
                </v-container>
            </v-form>
        </v-layout>
        <v-btn
            dark
            absolute
            bottom
            right
            fab
            color="green"
            style="bottom:20px;"
            @click.native="updateSpecies()"
            > <v-icon style="font-size:40px;padding-top:5px;">check</v-icon>
        </v-btn>
    </v-container>
</template>

<script>
const axios = require('axios').default;
export default {
    name: 'SpeciesEdit',
    data: function(){
        return{
            speciesSingle:{
                name:null,
                lastname:null,
                fiscalCode:null,
                birthday:null,
                email:null,
                telephone:null,
                mobilePhone:null,
                birthPlace:null,
                residenceStreet:null,
                residenceStreetNumber:null,
                residenceZipCode:null,
                residenceCity:null,
                residenceProvince:null
            }
        };
    },
    mounted: function(){
        let vm = this;
        vm.getSpeciesSingle();
    },
    methods:{
        getSpeciesSingle(){
            let vm = this;
            axios({
                method: "GET",
                url: vm.$API_BASE_URL + "species/getResource.php?speciesId="+vm.$route.params.speciesId,
                headers: {
                    'Authentication-Token': window.localStorage.getItem("herp_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.speciesSingle = response.data.resource;
                } 
                else{
                    alert(vm.$t('labels.errorLoading'));
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert(vm.$t('labels.errorLoading'));
                    console.error(error)
                }
            });
        },
        updateSpecies(){
            let vm = this;
            axios({
                method: "POST",
                url: vm.$API_BASE_URL + "species/edit.php",
                data: vm.speciesSingle,
                headers: {
                    'Authentication-Token': window.localStorage.getItem("herp_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.$router.push({name: 'speciesSingle', params:{speciesId:vm.$route.params.speciesId}});
                } 
                else{
                    alert(vm.$t('labels.errorLoading'));
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert(vm.$t('labels.errorLoading'));
                    console.error(error)
                }
            });
        }
    }
}
</script>
